import { Container, Image } from "semantic-ui-react";
import "./style.scss";
import { PageName } from "../../constants/common";
import { logout } from "../../reducer/user";
import { resetBooking } from "../../reducer/booking";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useEffect } from "react";

const ThankyouPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const isLogin = useAppSelector((state) => state.userInfo.isLogedin);
  useEffect(() => {
    if (isLogin) {
      dispatch(logout());
      dispatch(resetBooking());
    }
  }, [isLogin]);
  return (
    <div className="page thank">
      <div className="page-inner">
        <Container>
          <div className="content">
            <Image
              src={`${process.env.PUBLIC_URL}/images/yayyyy.png`}
              alt="thanh cong"
            />
            <p className="title">Chúc mừng bạn!</p>
            <div className="body">
              <p>Bạn đã thuê thành công phim "Nhà Bà Nữ"</p>
              <p>Vào Galaxy Play và thưởng thức phim ngay bạn nhé!</p>
            </div>

            <div className="footer">
              <a
                href="https://galaxyplay.vn/title/the-house-of-no-man"
                className="button primary-button"
                target="_blank"
              >
                Xem ngay
              </a>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
export default ThankyouPage;
